module.exports = __webpack_public_path__ + "media/images/common/shop/icon-document-3b302845dadabd8278a764127115b070.png";